export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const UPDATE_USER_END = 'UPDATE_USER_END';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCCESS';
export const UPDATE_ACCOUNT_END = 'UPDATE_ACCOUNT_END';
export const UPDATE_USER_DONE = 'UPDATE_USER_DONE';
